import { computed, type ComputedRef, type Ref, ref, unref } from 'vue';

import { tryOnBeforeUnmount } from '@vueuse/core';

import { MILLISECOND } from '@/references/constants';
import { settings } from '@/references/settings/globals';

export function useGatedRef(
  source: ComputedRef<boolean> | Ref<boolean>,
  gateDelay: number = 500 * MILLISECOND
): Readonly<Ref<boolean>> {
  if (!settings.useGatedRefs) {
    return source;
  }

  const gate = ref(unref(source));
  const gateHandle = setTimeout(() => (gate.value = true), gateDelay);
  tryOnBeforeUnmount(() => clearTimeout(gateHandle));

  return computed(() => unref(source) && gate.value);
}
